"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPeerDescriptor = void 0;
const utils_1 = require("@streamr/utils");
const crypto_1 = __importDefault(require("crypto"));
const isBrowserEnvironment_1 = require("../helpers/browser/isBrowserEnvironment");
const createPeerDescriptorSignaturePayload_1 = require("../helpers/createPeerDescriptorSignaturePayload");
const identifiers_1 = require("../identifiers");
const DhtRpc_1 = require("../../generated/packages/dht/protos/DhtRpc");
const calculateNodeIdRaw = (ipAddress, privateKey) => {
    // nodeId is calculated as 
    // concatenate(
    //   get104leastSignificatBits(hash(ipAddress)), 
    //   get56leastSignificatBits(sign(ipAddress))
    // )
    const ipAsBuffer = Buffer.alloc(4);
    ipAsBuffer.writeUInt32BE(ipAddress);
    const ipHash = utils_1.ECDSA_SECP256K1_EVM.keccakHash(ipAsBuffer);
    const signature = utils_1.ECDSA_SECP256K1_EVM.createSignature(ipAsBuffer, privateKey);
    const nodeIdRaw = Buffer.concat([
        ipHash.subarray(ipHash.length - 13, ipHash.length),
        signature.subarray(signature.length - 7, signature.length)
    ]);
    return nodeIdRaw;
};
const createPeerDescriptor = (connectivityResponse, region, nodeId) => {
    const privateKey = crypto_1.default.randomBytes(32);
    const publicKey = crypto_1.default.randomBytes(20); // TODO calculate publicKey from privateKey
    let nodeIdRaw;
    if (nodeId !== undefined) {
        nodeIdRaw = (0, identifiers_1.toDhtAddressRaw)(nodeId);
    }
    else {
        nodeIdRaw = calculateNodeIdRaw(connectivityResponse.ipAddress, privateKey);
    }
    const ret = {
        nodeId: nodeIdRaw,
        type: (0, isBrowserEnvironment_1.isBrowserEnvironment)() ? DhtRpc_1.NodeType.BROWSER : DhtRpc_1.NodeType.NODEJS,
        ipAddress: connectivityResponse.ipAddress,
        region,
        publicKey
    };
    if (connectivityResponse.websocket) {
        ret.websocket = {
            host: connectivityResponse.websocket.host,
            port: connectivityResponse.websocket.port,
            tls: connectivityResponse.websocket.tls
        };
    }
    ret.signature = utils_1.ECDSA_SECP256K1_EVM.createSignature((0, createPeerDescriptorSignaturePayload_1.createPeerDescriptorSignaturePayload)(ret), privateKey);
    return ret;
};
exports.createPeerDescriptor = createPeerDescriptor;
//# sourceMappingURL=createPeerDescriptor.js.map